import Event from 'models/event';
export const GOT_EVENT = 'got-event';
const gotEvent = ({ event }) => ({
  type: GOT_EVENT,
  payload: {
    event: new Event(event),
  },
});
export default gotEvent;
